import { injectIntl } from 'react-intl';
import TranslationsProvider from './TranslationsProvider';
import Translate from './Translate';
import LocalizeContext from './LocalizeContext';

const LocalizeConsumer = LocalizeContext.Consumer;

export { TranslationsProvider, Translate, injectIntl, LocalizeConsumer };
